import React, { Component } from "react";
import { Link } from "react-router-dom";
import KpitLogo from "./../../images/automate_kpi/kpit_logo_new.png";
import AutomateKpitLogo from "./../../images/automate_kpi/automate_kpi_icon.png";
import about from "./../../images/automate_kpi/about_automatekpi_logo.png";
import AdminLogo from "./../../images/automate_kpi/admin-avatar.png";

class Topbar extends Component {
  render() {
    return (
      <div data-test="automateKpitjav2TopbarComponent"
      style={{boxShadow:" 0px 1px 5px 1px grey"}}>
        <div
          className="navbar"
          style={{ display: "block", padding: "0%", margin: "0%" }}
        >
          <ul
            style={{
              backgroundColor: "#f8f9fa",
              margin: "0%",
              listStyleType: "none",
              padding: "0",
            }}
          >
            <li className="automatekpitlogo">
              <Link to="/navigate_new">
                <img
                  src={KpitLogo}
                  alt="Kpit_logo"
                  style={{
                    backgroundColor: "#f8f9fa",
                    width: "10%",
                    padding: "1%",
                  }}
                ></img>
              </Link>
              <Link to="/welcomeautomatekpi/landingkpidashboard">
                <img
                  src={AutomateKpitLogo}
                  alt="Kpit_logo"
                  style={{
                    backgroundColor: "#f8f9fa",
                    width: "15%",
                    padding: "1%",
                  }}
                ></img>
              </Link>
              <div
                style={{
                  display: "inline-block",
                  paddingLeft: "3%",
                  color: "#464646",
                  fontWeight: "bold",
                  fontSize: "25px",
                }}
              >
                AD Analytics
              </div>
              <img
                src={AdminLogo}
                alt="profile pic"
                style={{
                  float: "right",
                  width: "9%",
                  borderRadius: "50%",
                  paddingRight: "6%",
                  paddingTop: "1%",
                }}
              ></img>
              <img
                src={about}
                alt="to_do"
                style={{
                  float: "right",
                  width: "10%",
                  paddingTop: "2%",
                  paddingRight: "2%",
                }}
              ></img>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default Topbar;
